import { useApi } from "@shopexperts/shared";
import { useQuery } from "@tanstack/vue-query";
import { computed } from "vue";

export function usePageSchemas() {
  const api = useApi();

  const { data, isLoading, error, refetch } = useQuery({
    queryKey: ['admin', 'page-schemas'],
    queryFn: () => api.admin.pages.listSchemas({ query: { limit: 50 } }),
    staleTime: 5 * 60 * 1000,
    gcTime: 10 * 60 * 1000,
  });

  const schemas = computed(() => data.value?.data || []);

  return {
    schemas,
    isLoading,
    error,
    refetch,
  };
}

